var map = {
	"./AWS-icon.png": 9493,
	"./LinkedIn1000.png": 735,
	"./Litecoin.png": 4745,
	"./Ripple.png": 6716,
	"./Tumblr.png": 5124,
	"./ad.png": 1765,
	"./alerts.png": 7619,
	"./amazon-icon.png": 5942,
	"./app.png": 8501,
	"./art.png": 9919,
	"./assets.png": 1153,
	"./audio.png": 3322,
	"./audiomack.png": 678,
	"./auto.png": 7487,
	"./automation.png": 7051,
	"./azure.png": 8001,
	"./bank.png": 3132,
	"./basestarter.png": 476,
	"./binance.png": 54,
	"./bitbucket.png": 431,
	"./bitcoin.png": 3890,
	"./book.png": 2189,
	"./bookshelf.png": 7133,
	"./calendar.png": 8372,
	"./calendarevent.png": 3078,
	"./campaign_funding.png": 3158,
	"./campaign_marketing.png": 6633,
	"./chat.png": 8608,
	"./chat2.png": 3040,
	"./cix.png": 9484,
	"./cix2.png": 4916,
	"./classification.png": 2486,
	"./clock.png": 6738,
	"./cog.png": 8029,
	"./coinbase.png": 9990,
	"./collapse.png": 7871,
	"./computer.png": 3705,
	"./computer2.png": 2879,
	"./confluence.png": 4588,
	"./connect.png": 2098,
	"./connections.png": 4119,
	"./contact.png": 3624,
	"./contact2.png": 9320,
	"./contracts.png": 5561,
	"./csv.png": 2720,
	"./cubes.png": 1322,
	"./custom.png": 9735,
	"./dataset.png": 7916,
	"./dataset2.png": 2692,
	"./docker.png": 4574,
	"./documents.png": 7850,
	"./documents2.png": 5602,
	"./docusign.png": 8158,
	"./download.png": 3234,
	"./ebay.png": 861,
	"./ecb.png": 2542,
	"./email.png": 9396,
	"./email2.png": 4268,
	"./ethereum.png": 9721,
	"./etsy-icon.png": 7995,
	"./excel.png": 4301,
	"./fb250.png": 7561,
	"./files.png": 7417,
	"./files2.png": 3279,
	"./git-request.png": 16,
	"./git.png": 3412,
	"./gold.png": 2356,
	"./goldcoins.png": 6500,
	"./group.png": 9881,
	"./healthdata.png": 8456,
	"./hourglass.png": 8446,
	"./image.png": 8127,
	"./image2.png": 2493,
	"./imf.png": 8112,
	"./import.png": 265,
	"./info.png": 4882,
	"./instagram600.png": 1407,
	"./jira-512.png": 8085,
	"./knoweldge.png": 7770,
	"./knowledgebaselink.png": 635,
	"./knowledgebaselink2.png": 9521,
	"./knowledgebaselink3.png": 1128,
	"./lantern1.png": 6499,
	"./layout.png": 4335,
	"./ledger.png": 8465,
	"./linksdatabases.png": 5701,
	"./livestreaming.png": 962,
	"./lock.png": 1123,
	"./mailbox.png": 2952,
	"./marketing.png": 4660,
	"./money.png": 9831,
	"./music.png": 1005,
	"./narratives.png": 6083,
	"./notes.png": 6295,
	"./oecd.png": 6227,
	"./onlinepresence.png": 692,
	"./ons.png": 1522,
	"./palette.png": 3449,
	"./payment.png": 5122,
	"./paypal.png": 5235,
	"./pdf.png": 7438,
	"./photos.png": 2761,
	"./pics.png": 9469,
	"./pics2.png": 1563,
	"./pinterest.png": 3690,
	"./powerpoint.png": 6665,
	"./pricelookup.png": 3265,
	"./project.png": 8679,
	"./project2.png": 2661,
	"./projections.png": 3226,
	"./question.png": 7282,
	"./report.png": 1168,
	"./running.png": 4305,
	"./save.png": 8253,
	"./scales.png": 2943,
	"./send.png": 7128,
	"./signal.png": 286,
	"./skills.png": 8812,
	"./snapchat350.png": 2994,
	"./snaptheweb.png": 5399,
	"./social_google_box.png": 3079,
	"./software.png": 5961,
	"./soundcloud512.png": 9880,
	"./statistics.png": 3631,
	"./stock-market.png": 9621,
	"./stratagem.png": 1284,
	"./stripe.png": 7801,
	"./swap.png": 5099,
	"./tags.png": 8805,
	"./tasklist.png": 7037,
	"./tick.png": 9609,
	"./todo.png": 4638,
	"./tools.png": 4505,
	"./tradingeconomics.png": 1973,
	"./twitter256.png": 8282,
	"./user.png": 4503,
	"./user2.png": 7893,
	"./venture.png": 9417,
	"./venture2.png": 1359,
	"./venture3.png": 8070,
	"./venture4.png": 8153,
	"./venturestar.png": 7937,
	"./video.png": 3693,
	"./view2.png": 7603,
	"./vimeo.png": 712,
	"./website.png": 8295,
	"./whatsapp400.png": 8758,
	"./wizard.png": 7656,
	"./world.png": 8524,
	"./youtube1500.png": 7137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1413;